import * as React from 'react';
import Helmet from 'react-helmet';
import { Config } from '../../config/index';
import StaticBanner from '../../components/StaticBanner/index';
import { ComponentTheme } from '../../definitions/components';
import SubsidiarySite, { SubsidiarySiteAlignment } from '../../components/SubsidiarySite';
import './OurCompanies.css';
import OurCompanniesBanner from '../../assets/images/our-companies/our-company-main-banner.png';
import OurCompanniesBannerMobile from '../../assets/images/our-companies/our-company-main-banner-mobile.png';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';

export default function OurCompaniesPageRender(props, state) {
  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const OurCompaniesBannerImage = !!isMobile || !!isTablet ? OurCompanniesBannerMobile : OurCompanniesBanner;

        return (
          <React.Fragment>
            <Helmet>
              <title>Our Companies</title>
              <link rel="canonical" href={`${Config.FRONT_END_URL}/our-companies`} />
              <meta name="description" content={'Our Companies'} />
            </Helmet>

            <div className="page page--our-companies">
              <StaticBanner
                title={'Our Companies'}
                bannerImg={{
                  fit: 'cover',
                  src: OurCompaniesBannerImage
                }}
              />

              <div className="companies-nav-filter-container">
                <ul className="companies-nav-filter">
                  {this.navItems.map((navItem, i) =>
                    <li key={i}>
                      <button
                        className={i === state.filterActiveIndex ? 'active' : ''}
                        onClick={this.filterCompanies(navItem, i)}>
                        {navItem}
                      </button>
                    </li>)}
                </ul>
              </div>

              <div className="companies">
                {this.state.filteredCompanies.map((company, i) => {
                  if (i % 2 === 0) {
                    return (
                      <SubsidiarySite
                        {...company}
                        key={i}
                        alignment={SubsidiarySiteAlignment.LEFT}>
                      </SubsidiarySite>
                    );
                  } else {
                    return (
                      <SubsidiarySite
                        theme={ComponentTheme.DARK_TRANSPARENT}
                        btnTheme={ComponentTheme.LIGHT_TRANSPARENT}
                        key={i}
                        {...company} />
                    );
                  }
                })}
              </div>
            </div>

          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/OurCompanies/render.tsx